module.exports = __webpack_public_path__ + "static/img/6.110528d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/6.png
// module id = +j6R
// module chunks = 0